import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';

// Üst menü artık backend'den gelir (Menü Yönetimi: /admin/menu-management).
// Görünürlük filtresi SUNUCUDA uygulanır; buraya yalnızca kullanıcının
// görebileceği maddeler ulaşır.

export type MyMenuNode = {
  id: number;
  title: string;
  path: string | null;
  icon: string | null;
  display: 'dropdown' | 'mega';
  open_new_tab: boolean;
  children: MyMenuNode[];
};

export type MyMenuResponse = {
  /** false => firma için menü hiç tanımlanmamış; koddaki sabit menü kullanılır */
  configured: boolean;
  tree: MyMenuNode[];
};

export const MY_MENU_QUERY_KEY = ['menu-items', 'my'];

const API = `${process.env.REACT_APP_API_URL}`;
const cacheKey = (userId: number | string) => `aycrm_menu_tree_v1_${userId}`;

// Son başarılı menü tarayıcıda saklanır; sayfa yenilenince menü boş görünüp
// sonradan dolmasın diye ilk çizimde bu kopya kullanılır.
const readCache = (userId: number | string): MyMenuResponse | undefined => {
  try {
    const raw = localStorage.getItem(cacheKey(userId));
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    return parsed && Array.isArray(parsed.tree) ? (parsed as MyMenuResponse) : undefined;
  } catch {
    return undefined;
  }
};

const writeCache = (userId: number | string, data: MyMenuResponse) => {
  try {
    localStorage.setItem(cacheKey(userId), JSON.stringify(data));
  } catch {
    // depolama dolu/kapalı olabilir — menü yine de çalışır
  }
};

export const useMyMenu = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id;

  return useQuery(
    [...MY_MENU_QUERY_KEY, userId],
    async () => {
      const res = await axios.get(`${API}/menu-items/my`);
      const data = res.data?.data as MyMenuResponse;
      if (!data || !Array.isArray(data.tree)) throw new Error('Menü yanıtı geçersiz');
      return data;
    },
    {
      enabled: !!userId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
      placeholderData: () => (userId ? readCache(userId) : undefined),
      onSuccess: (data) => {
        if (userId) writeCache(userId, data);
      },
    },
  );
};
